/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import {wrapRootElement as RootWrapper} from './src/components/containers/RootWrapper'

export const wrapRootElement = RootWrapper
